const Assistant = () => {
    window.location.href = "/Assistant.html";
    return <></>;
  };

  export default Assistant;